import { Box } from '@mui/material'
import { getFirstItem } from 'lib/util'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'

/**
 * Cell styles
 */
const styles = () => ({
  actions: {
    gap: '0.75rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    alignItems: 'center',
  },
})

/**
 * Displays actions for the given message notification
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellNotificationActions = (classes, props = {}) => {
  const { value: { read, unreadMessages } } = props

  const isRead = getFirstItem(read)?.timestamp?.length || unreadMessages === 0 || false

  return (
    <Box
      className={classes.actions}
      sx={{ opacity: !isRead ? 1 : 0 }}
    >
      <Icon
        name={'dot'}
        size={'0.5rem'}
        color={'info'}
      />
    </Box>
  )
}

export default CellHOC(ListItemCellNotificationActions, styles)
